import getConfig from 'next/config';

import { getFrontendAppConfig } from '../config/frontendAppConfig';

const nextConfig = getConfig();
const frontendAppConfig = getFrontendAppConfig();

const CDN_ASSET_PREFIX =
  nextConfig?.publicRuntimeConfig?.CDN_ASSET_PREFIX || '';

// Used for static assets, e.g. images, anything stored under <root_dir>/static
const buildStaticAssetPath = url => {
  // Defaulting to assuming we are operting in production mode if `frontendAppConfig`
  // is not yet defined, to prevent any undiscovered race conditions between
  // writing and reading `frontendAppConfig` from impacting production.
  const prefix =
    frontendAppConfig?.isProduction === false
      ? `/_next/static`
      : `${CDN_ASSET_PREFIX}/_next/static`;

  // Prevent duplicated "//" which only cause problems in production
  return `${prefix}/${url.replace(/^\//, '')}`;
};

export default buildStaticAssetPath;
